module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "DedicationPage",
      "title": "Dedication"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedication"
  }, [_vm._v("To the first…"), _c('br'), _vm._v("\n  Walter Harper, an Alaska Native in 1913. He was joined by the mountaineering team co-led by Hudson Stuck and Harry Karstens, and included Robert Tatum.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4798650","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Dedication.vue
// module id = 69
// module chunks = 0